<template>
  <div class="timer panel-settings">
  </div>
</template>

<script>
export default {
};
</script>
